import '../Contact.css'

const Hero = () => {
  return (
    <div className='contact-bg'>
        
    </div>
  )
}

export default Hero